import {
  DocumentSnapshot,
  QuerySnapshot,
  collection,
  doc,
  getDoc,
  getDocs,
} from 'firebase/firestore';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { firestore } from 'services';
import { Story, StoryChapter } from 'types';

export const useStory = (id?: string) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [story, setStory] = useState<DocumentSnapshot<Story>>();
  const [chapters, setChapters] = useState<QuerySnapshot<StoryChapter>>();

  const storyQuery = useMemo(() => (id ? doc(firestore, `stories/${id}`) : null), [id]);
  const storyChaptersQuery = useMemo(
    () => (id ? collection(firestore, `stories/${id}/chapters`) : null),
    [id],
  );

  const fetchStory = useCallback(async () => {
    if (!storyQuery || !storyChaptersQuery) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const [storyData, chapters] = await Promise.all([
      getDoc(storyQuery),
      getDocs(storyChaptersQuery),
    ]);
    setStory(storyData as DocumentSnapshot<Story>);
    setChapters(chapters as QuerySnapshot<StoryChapter>);
    setLoading(false);
  }, [id, storyQuery, storyChaptersQuery]);

  useEffect(() => {
    fetchStory();
  }, [id]);

  return {
    story,
    chapters,
    isLoading,
  };
};
